export const onBoarding_help = require("./onboarding-help.png");
export const onBoarding_help_light = require("./onboarding-help-light.png");
export const onBoarding_language = require("./onboarding-language.png");
export const onBoarding_permission = require("./onboarding-permission.png");
export const permission_mic = require("./permission_microphone.png");
export const permission_location = require("./permission_location.png");
export const permission_camera = require("./permission_camera.png");
export const yolomedLogo = require("./yolomed_logo.png");
export const yolomedLogoLight = require("./yolomed_logo_light.png");
export const passwordLogo = require("./password.png");
export const pincodeLogo = require("./home_pin.png");
export const greetingLogo = require("./hello_image.png");
export const greetingPermission = require("./greeting_permission.png");
export const policyIcon = require("./policy_icon.png");
export const faceDetected = require("./face_detected.png");
export const faceDetectedRecord = require("./face_detected_record.png");
export const livenessDetected = require("./liveness_detected.png");
export const pnb_logo = require("./logo.png");
export const cibil_score = require("./cibil.png");
export const mdi_light_camera = require("./mdi_light_camera.svg");
export const bytesize_microphone = require("./bytesize_microphone.svg");
export const weui_location = require("./weui_location-outlined.svg");
